<template>
    <div class="tab-bar-wrapper">
        <ul class="left">
            <router-link :class="{active: routerName === 'home'}" to="/" tag="li">培训站应用</router-link>
            <router-link :class="{active: routerName === 'pilot'}" to="/pilot" tag="li">试装站应用</router-link>
            <router-link :class="{active: routerName === 'rework'}" to="/rework" tag="li">离线返修站应用</router-link>
            <router-link :class="{active: routerName === 'ilg'}" to="/ilg" tag="li">工具定位应用</router-link>
        </ul>
        <div class="operate">
            <span class="icon iconfont icon-pdf" @click="handlerPdf"></span>
            <span class="icon iconfont icon-shezhi" @click="handlerSet"></span>
        </div>
        <print-wrap ref="chartPrint" :set="set" :cs="cs" :img="img" :rt="rt"/>
    </div>
</template>

<script>
    import PrintWrap from './print'

    export default {
        name: 'TabBar',
        props: {
            set: Object,
            cs: Object,
            img: String,
            rt: String,
        },
        data() {
            return {
                routerName: this.$route.name
            }
        },
        components: {PrintWrap},
        methods: {
            handlerPdf() {
                this.$emit('on-pdf')
            },
            handlerSet() {
                this.$emit('on-set')
            },
        }
    }
</script>

<style lang="scss">
    @import "../style/color.scss";

    .tab-bar-wrapper {
        height: 72px;
        border-bottom: 1px solid #d6d7d9;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            flex: 1;
            display: flex;
            align-items: center;
            height: 100%;

            li {
                position: relative;
                list-style: none;
                padding: 0 11px;
                margin-right: 20px;
                cursor: pointer;
                display: flex;
                align-items: center;

                &.active {
                    color: $main-color;
                    font-weight: 700;
                    height: 100%;

                    &:after {
                        position: absolute;
                        content: "";
                        bottom: 0;
                        left: 0;
                        width: 60%;
                        border-top: 5px solid $main-color;
                        transform: translateX(32%);
                    }
                }


            }
        }

        .operate {
            padding: 0 15px;

            .icon {
                cursor: pointer;
                font-size: 30px;
                color: #aaa;

                &:hover {
                    color: #666;
                }

                &:nth-child(1) {
                    margin-right: 15px;
                }
            }
        }

        @media (max-width: 900px) {
            height: 50px;
            font-size: 12px;
            .left {
                padding-left: 5px;
                /*overflow-x: auto;*/
                /*-webkit-overflow-scrolling: touch;*/

                li {
                    /*white-space: nowrap;*/
                    padding: 0 5px;
                    margin-right: 0;
                    text-align: center;

                    &.active {
                        &:after {
                            border-top: 2px solid $main-color;
                        }
                    }
                }
            }
            .operate {
                .icon {
                    font-size: 20px;

                    &:nth-child(1) {
                        display: none;
                    }
                }
            }
        }
    }
</style>
